var _rect, _rect2, _rect3, _path, _circle, _circle2, _line, _line2, _line3, _line4, _line5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebdevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 641,
    height: 641,
    viewBox: "0 0 641 641",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 641,
    height: 641,
    fill: "url(#paint0_linear_1_16)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5,
    y: 154.5,
    width: 497,
    height: 308,
    stroke: "black",
    strokeWidth: 7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5,
    y: 154.5,
    width: 497,
    height: 47,
    stroke: "black",
    strokeWidth: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M537.721 164.818L543.994 175.523L550.266 164.818H554.903L546.448 177.909L554.903 191H550.266L543.994 180.841L537.721 191H533.085L541.403 177.909L533.085 164.818H537.721Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 179,
    r: 10,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 143,
    cy: 179,
    r: 10,
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 237.95,
    y1: 259.95,
    x2: 183.95,
    y2: 313.95,
    stroke: "black",
    strokeWidth: 14
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -7,
    x2: 76.3675,
    y2: -7,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 179 309)",
    stroke: "black",
    strokeWidth: 14
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -7,
    x2: 76.3675,
    y2: -7,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 421 262)",
    stroke: "black",
    strokeWidth: 14
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 479.95,
    y1: 320.95,
    x2: 425.95,
    y2: 374.95,
    stroke: "black",
    strokeWidth: 14
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 353.1,
    y1: 261.434,
    x2: 286.1,
    y2: 380.434,
    stroke: "black",
    strokeWidth: 14
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_16",
    x1: 4.13044e-8,
    y1: 319.167,
    x2: 641,
    y2: 321.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BF893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF49"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebdevelopment);
export default __webpack_public_path__ + "static/media/web development.239ba8a0ecc7f1e349bd0aba11c7beae.svg";
export { ForwardRef as ReactComponent };